import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import PropertyManagementIndustry from "@/pages/industries/PropertyManagementIndustry";
export const Route = createFileRoute("/industries/property-management")({ head: ({match}) => pageHead(match.pathname), component: () => (<PropertyManagementIndustry />) });
